import { CleanContent } from './ui';


export default function FinalCta() {
  return (
    <CleanContent><section className="py-5 text-center" id="create">
        <div className="container">
          <div className="eyebrow mb-2">Start Your Progression</div>
          <h2 className="h-lg mb-2">Create Your Shop Showcase</h2>
          <p className="p-md mx-auto mb-4" style={{ maxWidth: 520 }}>
            Start at 1 Star, build toward 10 Stars, join thousands of verified digital commerce merchants establishing authentic institutional prestige today
          </p>
          <a href="#create" className="btn btn-blue px-4 mb-4">Create Your Shop Showcase</a>
          <div className="d-flex flex-wrap justify-content-center gap-3 p-sm">
            {["Zero Paid Rank Inflation", "Audited User Base", "ISO Compliant Scoring Criteria"].map((t) => (
              <span key={t}><i className="bi bi-check-circle-fill check me-1" />{t}</span>
            ))}
          </div>
        </div>
      </section></CleanContent>
  );
}
